import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  DialogContent,
  DialogContentText
} from "@material-ui/core";
import Commons from "../../util/Commons";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import TextField from "@material-ui/core/TextField";

function isNumber(str) {
  if (str.trim() === '') {
    return false;
  }
  return !isNaN(str);
}

class ValidateInfoDialog extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      cell: "",
      message: "",
      contactId: null,
      isModalOpen: false
    };
  }

  handleOpenDialog = (e) => {
    if (Commons.validations.hasNotText(this.state.email.toString()) && Commons.validations.hasNotText(this.state.cell.toString())) {
      this.setState({
        ...this.state,
        message: "Ingrese la información de contacto.",
      });
    } else {
      this.setState({
        ...this.state,
        isModalOpen: false,
        email: this.state.email,
        contactId: this.props.contactId,
        cell: this.state.cell,
        message: ""
      });
    }
    this.props.handleAccept(this.props.contactId, this.state.email, this.state.cell);
  };

  handleCloseDialog = (e) => {
    this.setState({
      ...this.state,
      isModalOpen: false,
    });
  };

  handleAccept = (e) => {
    this.props.handleAccept(this.state.email, this.state.cell);
  };

  handleChangeEmail = (e) => {
    this.setState({
    ...this.state,
    email: e.target.value,
    });
  };

  handleChangeCell = (e) => {
    this.setState({
        ...this.state,
        cell: isNumber(e.target.value) ? e.target.value : '',
    });
  };

  render() {

    if (this.state.isModalOpen) {
      return (
        <ConfirmDialog
          open={this.state.isModalOpen}
          handleClose={this.handleCloseDialog}
          handleAccept={this.handleAccept}
          title={this.props.alertMessage}
        />
      );
    }

    return (
      <div>
        <Dialog open={this.props.open} onClose={this.props.handleClose} fullWidth maxWidth="xs">
          <DialogTitle>{this.props.title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{this.props.message}</DialogContentText>
            <TextField
              value={this.state.email}
              autoFocus
              fullWidth
              autoComplete="off"
              name="email"
              label="Email"
              onChange={this.handleChangeEmail}
              inputProps={{ maxLength: 100 }}
            />
            <br />
            <TextField
              value={this.state.cell}
              autoComplete="off"
              fullWidth
              name="cell"
              label="Celular"
              onChange={this.handleChangeCell}
              inputProps={{ maxLength: 10 }}
            />
            <br />
            <div>
              <p id="errorMessage" style={{ color: "red" }}>
                {this.state.message}
              </p>
            </div>
          </DialogContent>
          <DialogActions>
            <Button size="small" variant="contained" onClick={this.props.handleClose}>Cancelar</Button>
            <Button size="small" variant="contained"
            autoFocus color="primary" onClick={this.handleOpenDialog}>
              Validar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default ValidateInfoDialog;
